import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-block" }

import { TheUserDropdown, useTimezoneTime } from '@maropost-ui/liquidsky-ui'
import { useUserStore } from '@/lib/stores'
import useUserDropdownMenu from '@/lib/composable/usermenu/userDropdownMenu'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDropDown',
  props: {
    timezone: { default: 'UTC' }
  },
  setup(__props: any) {

const props = __props
const { displayTime } = useTimezoneTime(props.timezone)


/* --------------------------------------------------
 * Store
 * --------------------------------------------------
 */
const userStore = useUserStore()

/* --------------------------------------------------
 * Reactive Menu (AUTO-UPDATES ON ACCESS CHANGE)
 * --------------------------------------------------
 */
const userItems = useUserDropdownMenu()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TheUserDropdown), {
    items: _unref(userItems),
    username: _unref(userStore).username,
    onLogout: _unref(userStore).logout
  }, {
    "account-details": _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(displayTime)), 1)
    ]),
    _: 1
  }, 8, ["items", "username", "onLogout"]))
}
}

})